<div class="ts-tab">
  <!-- Property selector -->
  <tds-form-field>
    <tds-form-field-label>Timeseries Property</tds-form-field-label>
    <tds-combobox
      tds-form-field-item
      [value]="selectedProperty()"
      (selectionChange)="onPropertySelect($any($event.value))"
      selectionMode="single"
    >
      <input tds-combobox-input placeholder="Select a property..." />
      @for (prop of timeseriesProperties(); track prop.name) {
        <tds-combobox-single-item [value]="prop.name">
          {{ prop.name }}
        </tds-combobox-single-item>
      }
    </tds-combobox>
  </tds-form-field>

  <!-- Date range -->
  <div class="ts-tab__row">
    <tds-form-field>
      <tds-form-field-label>Start Date</tds-form-field-label>
      <tds-datepicker
        tds-form-field-item
        displayFormat="yyyy-MM-dd"
        locale="en-US"
      >
        <input
          tds-datepicker-input
          [value]="dateFrom()"
          (valueChange)="dateFrom.set($event)"
          placeholder="Start date"
        />
      </tds-datepicker>
    </tds-form-field>
    <tds-form-field>
      <tds-form-field-label>End Date</tds-form-field-label>
      <tds-datepicker
        tds-form-field-item
        displayFormat="yyyy-MM-dd"
        locale="en-US"
      >
        <input
          tds-datepicker-input
          [value]="dateTo()"
          (valueChange)="dateTo.set($event)"
          placeholder="End date"
        />
      </tds-datepicker>
    </tds-form-field>
  </div>

  <!-- Interpolation -->
  <div class="ts-tab__field">
    <tds-checkbox
      [checked]="interpolationEnabled()"
      (checkedChange)="interpolationEnabled.set($event)"
    >
      Enable data interpolation
    </tds-checkbox>
  </div>

  @if (interpolationEnabled()) {
    <div class="ts-tab__interpolation">
      <fieldset class="ts-tab__fieldset">
        <legend class="ts-tab__legend">Frequency</legend>
        <tds-radio>
          <input
            tds-radio-input
            type="radio"
            name="frequency"
            value="hourly"
            [checked]="interpolationFrequency() === 'hourly'"
            (change)="interpolationFrequency.set('hourly')"
          />
          <label tds-radio-label>Hourly</label>
        </tds-radio>
        <tds-radio>
          <input
            tds-radio-input
            type="radio"
            name="frequency"
            value="daily"
            [checked]="interpolationFrequency() === 'daily'"
            (change)="interpolationFrequency.set('daily')"
          />
          <label tds-radio-label>Daily</label>
        </tds-radio>
        <tds-radio>
          <input
            tds-radio-input
            type="radio"
            name="frequency"
            value="weekly"
            [checked]="interpolationFrequency() === 'weekly'"
            (change)="interpolationFrequency.set('weekly')"
          />
          <label tds-radio-label>Weekly</label>
        </tds-radio>
        <tds-radio>
          <input
            tds-radio-input
            type="radio"
            name="frequency"
            value="monthly"
            [checked]="interpolationFrequency() === 'monthly'"
            (change)="interpolationFrequency.set('monthly')"
          />
          <label tds-radio-label>Monthly</label>
        </tds-radio>
      </fieldset>

      <fieldset class="ts-tab__fieldset">
        <legend class="ts-tab__legend">Strategy</legend>
        <tds-radio>
          <input
            tds-radio-input
            type="radio"
            name="strategy"
            value="last"
            [checked]="interpolationStrategy() === 'last'"
            (change)="interpolationStrategy.set('last')"
          />
          <label tds-radio-label>Last</label>
        </tds-radio>
        <tds-radio>
          <input
            tds-radio-input
            type="radio"
            name="strategy"
            value="next"
            [checked]="interpolationStrategy() === 'next'"
            (change)="interpolationStrategy.set('next')"
          />
          <label tds-radio-label>Next</label>
        </tds-radio>
        <tds-radio>
          <input
            tds-radio-input
            type="radio"
            name="strategy"
            value="linear"
            [checked]="interpolationStrategy() === 'linear'"
            (change)="interpolationStrategy.set('linear')"
          />
          <label tds-radio-label>Linear</label>
        </tds-radio>
      </fieldset>
    </div>
  }

  <!-- Query button -->
  <div class="ts-tab__actions">
    <button
      tds-button
      variant="primary"
      size="md"
      [disabled]="!canQuery()"
      (click)="onQuery()"
    >
      Query
    </button>
  </div>

  <!-- Error message -->
  @if (error()) {
    <div class="ts-tab__error">{{ error() }}</div>
  }

  <!-- Loading indicator -->
  @if (isLoading()) {
    <div class="ts-tab__loading">Loading...</div>
  }

  <!-- Empty state -->
  @if (showEmpty()) {
    <div class="ts-tab__empty">
      No data points found for the selected range.
    </div>
  }

  <!-- Results -->
  @if (dataPoints().length > 0 && !isLoading()) {
    <div class="ts-tab__results">
      <div class="ts-tab__view-toggle">
        <button
          tds-icon-button
          variant="tertiary"
          size="sm"
          label="Table view"
          [class.active]="displayMode() === 'table'"
          (click)="displayMode.set('table')"
        >
          <tds-icon [name]="$any('table_chart')"></tds-icon>
        </button>
        <button
          tds-icon-button
          variant="tertiary"
          size="sm"
          label="Chart view"
          [class.active]="displayMode() === 'chart'"
          (click)="displayMode.set('chart')"
        >
          <tds-icon [name]="$any('show_chart')"></tds-icon>
        </button>
      </div>

      @if (displayMode() === 'table') {
        <lib-timeseries-data-table [dataPoints]="dataPoints()" />
      }

      @if (displayMode() === 'chart') {
        <div class="ts-tab__chart" echarts [options]="chartOptions()"></div>
      }
    </div>
  }
</div>
